import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Crown } from 'lucide-react';
import { cn } from '../../lib/cn.js';
import styles from './Badge.module.css';
/** Presentational status/PRO/credits pill — status chips (§6.4), PRO badge
 * (crown + text, never color-alone per CLAUDE_DESIGN.md §9), credits chip. */
export function Badge({ tone = 'neutral', children, icon, className }) {
    return (_jsxs("span", { className: cn(styles['badge'], styles[tone], className), children: [tone === 'pro' && !icon && _jsx(Crown, { size: 11, "aria-hidden": "true" }), icon, children] }));
}
